import { sendIt } from 'gatsby-plugin-purina-analytics/common/functions';
import React from 'react';
import { Link } from '../Link';

interface Props {
  offer: Offer[];
  title: string;
}

const ProductOfferBanner: React.FC<Props> = ({ offer, title }) => {
  const currentOffer = offer[0];

  if (typeof currentOffer === 'undefined') {
    return null;
  }
  return (
    <div
      role="region"
      aria-label="Offers or Rebates"
      className="!pds-m-0 pds-flex pds-justify-center !pds-rounded-none !pds-border-none pds-bg-neutral !pds-p-3.5 pds-text-neutral-text"
    >
      <Link
        cmsTheme="dark"
        onClick={() =>
          sendIt({
            event: 'module_interaction',
            eventParams: {
              component_type: 'offer_banner',
              component_id: 'product_offer_cta',
              product_name: title,
              page_type: 'pdp',
              content_name: currentOffer.title,
            },
          })
        }
        className="pds-text-neutral-text pds-no-underline"
        to={currentOffer.path.alias}
      >
        {'Offer or rebate for this product '}
        <span aria-hidden="true">{'->'}</span>
      </Link>
    </div>
  );
};
export default ProductOfferBanner;
